import { takeEvery, put, call } from 'redux-saga/effects';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../shared/api/headers';
import { GET_LOGIN_PAGE_LOGO_URL, DEFAULT_BASE_URL } from '../../shared/api/urls';
import { apiRequest } from '../../shared/api';
import { setLoginPageLogoAction } from '../../actions/actionCreators';
import { GET_LOGIN_PAGE_LOGO } from '../../actions/actionTypes';

function* getLoginPageLogoURLAsync() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: DEFAULT_BASE_URL,
        url: GET_LOGIN_PAGE_LOGO_URL,
    };
    try {
        const { data } = yield call(apiRequest, requestConfig);
        yield put(setLoginPageLogoAction(data.logoUrl));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}

export default function* watchGetLoginPageLogoURL() {
    yield takeEvery(GET_LOGIN_PAGE_LOGO, getLoginPageLogoURLAsync);
}
